<template>
    <app-layout v-if="isPageReady" printClass="print-referral-listing">
        <div>
            <div>
                <div>
                    <div class="referral-tracking__main-tabs">
                        <button type="button" :class="mainTabClass('provider')" @click="goToProviderReferrals">
                            {{ $t('pages.referrals.index.referrals_made.provider_received_referral') }}
                            <span v-if="totalReferralWithPendingActionCount" class="referral-tracking__count-information">
                                {{ totalReferralWithPendingActionCount }}
                            </span>
                        </button>
                        <button type="button" :class="mainTabClass('patient')" @click="goToPatientReferrals">
                            {{ $t('pages.referrals.index.referrals_made.provider_received_request') }}
                            <!-- <span class="referral-tracking__count-information">{{ $t('pages.referrals.index.referrals_made.count') }}</span> -->
                        </button>
                    </div>
                </div>

                <div v-if="activeMainTab === 'provider'">
                    <provider-referrals></provider-referrals>
                </div>

                <div v-if="activeMainTab === 'patient'" class="referral-tracking__patient-requests-section">
                    <referrals-made></referrals-made>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralService from 'services/ReferralService'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ReferralStatusEnum from '@/enums/ReferralStatusEnum'
    import ProviderReferrals from 'components/page-elements/referrals/ProviderReferrals'
    import ReferralsMade from 'components/page-elements/referrals/ReferralsMade'
    import Store from '~/store'
    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],
        components: {
            AppLayout,
            ProviderReferrals,
            ReferralsMade,
        },
        data() {
            return {
                activeReferralTab: 'made',
                activePatientTab: 'requests',
                showPatientDetailsModal: false,
                activeReferral: {},
                PracticeTypeEnum: PracticeTypeEnum,
                practiceData: {},
                dropdownStates: {},
                actionStates: {},
            }
        },
        provide() {
            return {
                isReferralPool: false,
            }
        },
        computed: {
            activeMainTab() {
                return this.$route.name?.startsWith('referrals-patient') ? 'patient' : 'provider'
            },
            tabOptions() {
                const tabs = [
                    {
                        displayName: this.$t('layouts.app.topnav.provider_direct'),
                        name: 'referrals',
                        icon: 'direct-referral',
                        badge: this.$route.params.type === 'received' ? this.getReceivedDirectReferralFromProviderCount() : null,
                    },
                ]

                if (!this.$auth.isUserTemporaryPhysician()) {
                    tabs.push({
                        displayName: this.$t('layouts.app.topnav.provider_match'),
                        name: 'pool',
                        icon: 'match-referral',
                        badge:
                            this.$route.params.type === 'received'
                                ? this.referralsByStatuses?.received.find(
                                      (r) => r.referralStatus === ReferralStatusEnum.REFERRALS_POOL_RECEIVED,
                                  )?.count
                                : this.referralsByStatuses?.received?.find(
                                      (r) => r.referralStatus === ReferralStatusEnum.REFERRALS_POOL_SLOTS_PROPOSED,
                                  )?.count,
                    })
                }

                if (
                    this.$route.params.type === 'received' &&
                    (this.$auth.isActiveMemberPhysician() || this.$auth.isPracticeAncillary())
                ) {
                    tabs.push(
                        {
                            displayName: this.$t('layouts.app.topnav.patient_direct'),
                            name: 'referrals-patient',
                            icon: 'match-referral',
                            badge: this.referralsByStatuses?.received.find(
                                (r) => r.referralStatus === ReferralStatusEnum.CREATED_BY_PATIENT,
                            )?.count,
                        },
                        {
                            displayName: this.$t('layouts.app.topnav.patient_match'),
                            name: 'pool-patient',
                            icon: 'match-referral',
                            badge: this.referralsByStatuses?.received.find(
                                (r) => r.referralStatus === ReferralStatusEnum.REFERRALS_POOL_RECEIVED_BY_PATIENT,
                            )?.count,
                        },
                    )
                }
                return tabs
            },
            totalReferralWithPendingActionCount() {
                if (this.$auth.isUserTemporaryPhysician()) {
                    return 1
                }

                return this.getReceivedReferralWithPendingActionCount() + this.getMadeReferralWithPendingActionCount()
            },
        },
        methods: {
            mainTabClass(tab) {
                return ['referral-tracking__main-tab', { active: this.activeMainTab === tab }]
            },
            toggleReferralDropdown(index) {
                this.dropdownStates[index] = !this.dropdownStates[index]
            },
            toggleDropdown(index) {
                Object.keys(this.dropdownStates).forEach((key) => {
                    if (key != index) {
                        this.$set(this.dropdownStates, key, false)
                    }
                })

                this.$set(this.dropdownStates, index, !this.dropdownStates[index])
            },

            closeDropdown(index) {
                this.$set(this.dropdownStates, index, false)
            },

            getDropdownPosition() {
                return {
                    position: 'absolute',
                    top: '80%',
                    right: '8px',
                    marginTop: '4px',
                    height: 'auto',
                    zIndex: 1000,
                }
            },

            getCreatedDate(referral) {
                if (!referral || !referral.createdAt) return 'N/A'
                return new Date(referral.createdAt).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                })
            },

            printPage() {
                window.print()
            },
            getUserFullName(patient) {
                return patient ? `${patient.firstName} ${patient.lastName}` : 'N/A'
            },
            getPatientDateOfBirth(patient) {
                return patient ? '01/01/1990' : 'N/A'
            },
            changeTab(event) {
                this.$router.push({ name: `referrals.${this.$route.params.type}.${event}` })
            },
            getReceivedDirectReferralFromProviderCount() {
                return (
                    this.referralsByStatuses?.received
                        ?.filter(
                            (r) =>
                                r.referralStatus === ReferralStatusEnum.PATIENT_VISIT_PAST ||
                                r.referralStatus === ReferralStatusEnum.CREATED,
                        )
                        ?.reduce((acc, curr) => acc + curr.count, 0) || 0
                )
            },
            fetchReceivedReferralsCountByStatus() {
                const params = {}
                if (this.$auth.isPracticeAncillary()) {
                    params.toPracticeId = this.$auth.getPractice().id
                } else {
                    params.toUserId = this.$auth.getUser().id
                }
                ReferralService.fetchReferralsCountByStatus(params, 'received')
            },
            fetchMadeReferralsCountByStatus() {
                const params = {}
                if (this.$auth.isPracticeAncillary()) {
                    params.fromPracticeId = this.$auth.getPractice().id
                } else {
                    params.fromUserId = this.$auth.getUser().id
                }
                ReferralService.fetchReferralsCountByStatus(params, 'made')
            },
            goToProviderReferrals() {
                if (this.$route.name?.startsWith('referrals.')) return
                this.$router.push({
                    name: 'referrals.received',
                })
            },

            goToPatientReferrals() {
                this.$router.push({
                    name: 'referrals-patient.received',
                })
            },

            getReceivedReferralWithPendingActionCount() {
                if (this.$auth.isUserTemporaryPhysician()) {
                    return 1
                }

                const referrals = Store.getters['auth/getPendingReferralAction'].received?.filter(
                    (status) =>
                        status.referralStatus === ReferralStatusEnum.CREATED ||
                        status.referralStatus === ReferralStatusEnum.PATIENT_VISIT_PAST ||
                        status.referralStatus === ReferralStatusEnum.REFERRALS_POOL_RECEIVED ||
                        status.referralStatus === ReferralStatusEnum.REFERRALS_POOL_RECEIVED_BY_PATIENT,
                )

                return referrals?.reduce((acc, curr) => {
                    return acc + +curr.count
                }, 0)
            },

            getMadeReferralWithPendingActionCount() {
                const referrals = Store.getters['auth/getPendingReferralAction'].made?.filter(
                    (status) => status.referralStatus === ReferralStatusEnum.REFERRALS_POOL_SLOTS_PROPOSED,
                )

                return referrals?.reduce((acc, curr) => {
                    return acc + +curr.count
                }, 0)
            },
        },
    }
</script>
